<nz-descriptions [nzBordered]="true">
  <nz-descriptions-item [nzTitle]="'Item No.' | locale">{{itemCode}}</nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Description' | locale">{{itemDescription}}</nz-descriptions-item>
  <nz-descriptions-item *ngIf="allowShowAllInPriceHistory" [nzTitle]="'Customer Filter' | locale">
    <nz-select
      [(ngModel)]="selectedCardCode"
      (ngModelChange)="onCardCodeSelectionChange()"
      style="width: 160px"
    >
      <nz-option [nzValue]="cardCode" [nzLabel]="cardCode"></nz-option>
      <nz-option [nzValue]="allCardCodeOption" nzLabel="All"></nz-option>
    </nz-select>
  </nz-descriptions-item>
  <nz-descriptions-item
    *ngIf="!isAllCustomersSelected"
    [nzTitle]="'Customer No.' | locale"
  >{{cardCode}}</nz-descriptions-item>
  <nz-descriptions-item
    *ngIf="!isAllCustomersSelected"
    [nzTitle]="'Customer Name' | locale"
  >{{cardName}}</nz-descriptions-item>
</nz-descriptions>

<nz-table
  #basicTable
  [nzData]="isAllCustomersSelected ? filteredPriceHistory : priceHistory"
  [nzLoading]="isLoading"
  [nzSize]="'middle'"
  nzShowPagination="true"
>
  <thead>
    <tr>
      <th *ngIf="isAllCustomersSelected">
        Customer No.
        <input
          nz-input
          [(ngModel)]="filters.CardCode.singleValue"
          (ngModelChange)="applyFilters()"
        />
      </th>
      <th *ngIf="isAllCustomersSelected">
        Customer Name
        <input
          nz-input
          [(ngModel)]="filters.CardName.singleValue"
          (ngModelChange)="applyFilters()"
        />
      </th>
      <th>
        Order Date
        <div *ngIf="isAllCustomersSelected" class="price-history-filter-range">
          <nz-date-picker
            [(ngModel)]="filters.DocDate.valueFrom"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'From' | locale"
          ></nz-date-picker>
          <nz-date-picker
            [(ngModel)]="filters.DocDate.valueTo"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'To' | locale"
          ></nz-date-picker>
        </div>
      </th>
      <th>
        Order Number
        <div *ngIf="isAllCustomersSelected" class="price-history-filter-range">
          <nz-input-number
            [(ngModel)]="filters.DocNum.valueFrom"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'From' | locale"
          ></nz-input-number>
          <nz-input-number
            [(ngModel)]="filters.DocNum.valueTo"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'To' | locale"
          ></nz-input-number>
        </div>
      </th>
      <th>
        Item Code
        <input
          *ngIf="isAllCustomersSelected"
          nz-input
          [(ngModel)]="filters.ItemCode.singleValue"
          (ngModelChange)="applyFilters()"
        />
      </th>
      <th>
        Item Description
        <input
          *ngIf="isAllCustomersSelected"
          nz-input
          [(ngModel)]="filters.Dscription.singleValue"
          (ngModelChange)="applyFilters()"
        />
      </th>
      <th *ngIf="showUOMInPriceHistory">
        UOM
        <input
          *ngIf="isAllCustomersSelected"
          nz-input
          [(ngModel)]="filters.UomCode.singleValue"
          (ngModelChange)="applyFilters()"
        />
      </th>
      <th>
        Unit Price
        <div *ngIf="isAllCustomersSelected" class="price-history-filter-range">
          <nz-input-number
            [(ngModel)]="filters.PriceBefDi.valueFrom"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'From' | locale"
          ></nz-input-number>
          <nz-input-number
            [(ngModel)]="filters.PriceBefDi.valueTo"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'To' | locale"
          ></nz-input-number>
        </div>
      </th>
      <th>
        Discount (%)
        <div *ngIf="isAllCustomersSelected" class="price-history-filter-range">
          <nz-input-number
            [(ngModel)]="filters.DiscPrcnt.valueFrom"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'From' | locale"
          ></nz-input-number>
          <nz-input-number
            [(ngModel)]="filters.DiscPrcnt.valueTo"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'To' | locale"
          ></nz-input-number>
        </div>
      </th>
      <th>
        Net Unit Price
        <div *ngIf="isAllCustomersSelected" class="price-history-filter-range">
          <nz-input-number
            [(ngModel)]="filters.Price.valueFrom"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'From' | locale"
          ></nz-input-number>
          <nz-input-number
            [(ngModel)]="filters.Price.valueTo"
            (ngModelChange)="applyFilters()"
            [nzPlaceHolder]="'To' | locale"
          ></nz-input-number>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let record of basicTable.data">
      <td *ngIf="isAllCustomersSelected">{{ record.CardCode }}</td>
      <td *ngIf="isAllCustomersSelected">{{ record.CardName }}</td>
      <td>{{ record.DocDate }}</td>
      <td>{{ record.DocNum }}</td>
      <td>{{ record.ItemCode }}</td>
      <td>{{ record.Dscription }}</td>
      <td *ngIf="showUOMInPriceHistory">{{ record.UomCode }}</td>
      <!--<td>{{ record.quantityOrdered }}</td>
       <td>{{ record.currency }}</td> -->
      <td>{{ record.PriceBefDi }}</td>
      <td>{{ record.DiscPrcnt }}%</td>
      <td>{{ record.Price }}</td>
      <!-- <td>{{ record.lineTotal | currency: record.currency }}</td> -->
      <!-- <td>{{ record.orderStatus }}</td> -->
    </tr>
  </tbody>
</nz-table>

<nz-alert *ngIf="error" nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
